// ----------------------------------------------------------------------
// <copyright file="Izenda.IconMenu.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * IconMenu component
 */
import React, { Component } from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import LayoutUtils from 'share/utils/Izenda.LayoutUtils';

@observer
export default class IconMenu extends Component {
  @observable isExpanded = false;

  handleClick = () => {
    LayoutUtils.toggleIconMenu();
    LayoutUtils.toggleMiddelPanel(false);
    LayoutUtils.toggleSideBar();

    this.isExpanded = !this.isExpanded;
  };

  render() {
    const iconClasses = classnames({
      'izenda-NavIcon': true,
      expanded: this.isExpanded,
      collapsed: !this.isExpanded
    });
    let style = {};
    if(this.isExpanded) {
      style = {
        'margin-top': '15px'
      }
    }
    return (
      <a
        className={classnames(['izenda-IconMenu', this.props.className])}
        onClick={this.handleClick}
        aria-expanded="false"
        style={style}
      >
        <div className={iconClasses}>
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.IconMenu.jsx